import { Box, FormLabel, TextField, Autocomplete } from '@mui/material';

const FormikAuto = ({ formik, name, label, options, getOptionLabel, isOptionEqualToValue, ...props }) => {
  return (
    <Box>
      <FormLabel sx={{ fontStyle: "inherit", color: "#000000" }}>
        {label}
      </FormLabel>
      <Autocomplete
        options={options}
        getOptionLabel={getOptionLabel || ((option) => option?.label || '')}
        isOptionEqualToValue={isOptionEqualToValue || ((option, value) => option?.value === value)}
        onChange={(_, value) => {
          formik.setFieldValue(name, value ? value.value : ""); 
        }}
        onBlur={() => formik.setFieldTouched(name, true)}
        value={options.find(option => option.value === formik.values[name]) || null} 
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              mt: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                bgcolor: "white"
              }
            }}
            fullWidth
            error={formik.touched[name] && Boolean(formik.errors[name])}
            helperText={formik.touched[name] && formik.errors[name]}
          />
        )}
        {...props}
      />
    </Box>
  );
};

export default FormikAuto;
